<template>
	<div class="orderDetails"  >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-orderManage Icon" ></i>
			<!-- <span class="p-l-10 p-r-10 ">/</span> -->
			<span class="header_text">/ 项目任务 / 订单详情</span>
		</div>
		<div class="content_Box box-shadow p-l-10 p-r-10" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<el-collapse v-model="activeNames">
			  <el-collapse-item name="1">
			    <template slot="title">
			      <b class="font-16 p-l-5">订单详情</b>
			    </template>
				<div class="towContent p-t-5">
					<div class="clear row-info">
						<div class="fl title-key">姓名 ：</div>
						<div class="fl list-cont" >
							<span >{{projectArr.name}}</span>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">身份证 ：</div>
						<div class="fl list-cont" >
							<span class="font-Tahoma">{{projectArr.identity | id_blank}}</span>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">银行 ：</div>
						<div class="fl list-cont" >
							<span >{{projectArr.banK_name}}</span>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">分行支行 ：</div>
						<div class="fl list-cont" >
							<span >{{projectArr.opening_bank}}</span>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">卡号 ：</div>
						<div class="fl list-cont"  >
							<span class="font-Tahoma">{{projectArr.bank_card | sub_blank}}</span>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">金额 ：</div>
						<div class="fl list-cont" >
							<b class="font-consolas text-color-red">{{projectArr.money | filterNumber}} 元</b>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">税费服务费 ：</div>
						<div class="fl list-cont" >
							<span class="font-consolas ">{{projectArr.rate_money | filterNumber}} 元</span>
							<span class="suffix">（含个人所得税、增值税、平台服务费）</span>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">总费用 ：</div>
						<div class="fl list-cont" >
							<b class="font-consolas ">{{projectArr.settlement_money | filterNumber}} 元</b>
						</div>
					</div>
					<div class="clear row-info" v-if="projectArr.status == '1' ">
						<div class="fl title-key">结算时间 ：</div>
						<div class="fl list-cont" >
							<span class="font-Tahoma ">{{projectArr.settlement_time}}</span>
						</div>
					</div>
					<div class="clear row-info" >
						<div class="fl title-key">状态 ：</div>
						<div class="fl list-cont" >
							<span class="dd-state-0" v-if="projectArr.status=='0'" >打款失败</span>
							<span class="dd-state-1" v-if="projectArr.status=='1'" >打款成功</span>
							<span class="dd-state-2" v-if="projectArr.status=='2'" >入账中</span>
							<span class="dd-state-3" v-if="projectArr.status=='3'" >退票</span>
							<span class="dd-state-4" v-if="projectArr.status=='4'" >已接单</span>
							<span class="dd-state-5" v-if="projectArr.status=='5'" >驳回</span>
							<span class="dd-state-8" v-if="projectArr.status=='8'" >打款中</span>
							<span class="dd-state-9" v-if="projectArr.status=='9'" >待打款</span>
							<span class="dd-state-10" v-if="projectArr.status=='10'" >已作废</span>
						</div>
					</div>
				</div>
			  </el-collapse-item>
			  <el-collapse-item name="2">
			    <template slot="title">
				   <b class="font-16 p-l-5">项目概况</b>
			    </template>
				<div class="oneContent p-t-5">
					<div class="clear row-info">
						<div class="fl title-key">项目名称 ：</div>
						<div class="fl list-cont" >
							<span class="cursor-pointer text-color-blue" @click="gotToProjectList">{{projectArr.project_name}}</span>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">省市 ：</div>
						<div class="fl list-cont" >
							<span >{{projectArr.district}} - {{projectArr.city}}</span>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">时间 ：</div>
						<div class="fl list-cont" >
							<span >{{projectArr.start_time}} ~ {{projectArr.end_time}}</span>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">类型 ：</div>
						<div class="fl list-cont" >
							<span >{{projectArr.type}}</span>
						</div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">描述 ：</div>
						<div class="fl list-cont"><el-input type="textarea" readonly :rows="6" v-model="projectArr.content"></el-input> </div>
					</div>
					<div class="clear row-info">
						<div class="fl title-key">地址 ：</div>
						<div class="fl list-cont"> {{projectArr.address | isData}} </div>
					</div>
					<div class="clear"></div>
				</div>
			  </el-collapse-item>
			</el-collapse>
			<div class="border-top-1">
				<span class='resetBtn' @click="back">返 回</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'orderDetails',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				activeNames:['1','2'],
				projectArr:{},  //订单详情
				id:'2',
				type:'',	//判断状态
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //判断是否登录
					window.location = 'login.html';
					return;
				}
				this.id = this.$route.query.id;
				this.type = this.$route.query.type;
				this.getOrderList();
			},
			getOrderList(){
				let fn = new FormData();
				fn.append('id', this.id); //文件
				this.$http.post(this.url + '/zhongfy/company/OrderDetails', fn).then((res) => {
					if (res.data.code == '200' || res.data.msg == '成功') {
						let data = res.data.data;
						this.projectArr = data;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else{
						this.$message.error(res.data.msg);
					}
				}, (res) => {
					this.$message.error('网络错误');
				})
			},
			back(){
				this.$router.go(-1)
			},
			gotToProjectList(row){
				this.$router.push('/projectManage')
			},
		},
		filters:{
		 
		}
	}
</script>

<style scoped>
	.orderDetails {}
	.border-top-1{border-top: 1px solid #EBEBEB;	padding: 20px 0 20px 90px;}	
	.border-top-1 .resetBtn{padding: 0 30px;}
	.suffix {font-size: 12px !important;color: #999999;}
</style>



// WEBPACK FOOTER //
// src/components/OrderDetail.vue